$(document).ready(function() {

   initDnDataTable();
});

var initDnDataTable = function() {
    switch (translationTo.language) {
        case "de":
            languageOption = dataTableGerman;
            break;
        case "es":
            languageOption = dataTableSpanish;
            break;
        case "fr":
            languageOption = dataTableFrench;
            break;
        case "it":
            languageOption = dataTableItalian;
            break;
        default:
            languageOption = dataTableEnglish;
            break;
    }

    var options = {
        "processing": true,
        "language": languageOption,
        "scrollX": true,
        "retrieve": true
    };

    $('.dnTableResponsive-table-dataTable').each(function () {

        if ($(this).attr('data-datatable-url')) {
            options["ajax"] = {
                "url": $(this).attr('data-datatable-url'),
                "type": "POST"
            };
        }

        $(this).dataTable(options);
    });
};

$(document).on('click','.dnTableResponsive-table-tr-isLinkClick', function(e){
    e.preventDefault();
    var url = $(this).attr('data-url');
    var target = $(this).attr('data-target');
    window.open(url, target);
});

$(document).on('loaded.bs.modal', '.dnJs-modal-with-dataTable', function (e) {
    initDnDataTable();
});

$(document).on('loaded.form.ajax', function () {
    initDnDataTable();
});